import script from "./NestedNavElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./NestedNavElement.vue?vue&type=script&setup=true&lang=ts"

import "./NestedNavElement.vue?vue&type=style&index=0&id=82d8ee40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82d8ee40"]])

export default __exports__